import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
    max-width: 100%;
    height: auto;
`;

const ResponsiveImage = ({height, width, src, alt, ...props}) => (
    <div>
        <Image src={src} alt={alt} width={width} height={height} />
    </div>
);

export default ResponsiveImage;


// WEBPACK FOOTER //
// ./src/components/ResponsiveImage.js